/**
 * LegalDisclaimer - Terms of Service and Privacy Policy agreement text
 *
 * Displays legal disclaimer with links to Terms of Service and Privacy Policy
 */

import { Urls } from '@/constants/urls';

interface LegalDisclaimerProps {
  /** Optional className for custom styling */
  className?: string;
}

export function LegalDisclaimer({ className = '' }: LegalDisclaimerProps) {
  return (
    <p className={`text-center text-xs text-slate-500 ${className}`}>
      By joining Catch, you agree to our{' '}
      <a
        href={Urls.terms_of_service}
        target="_blank"
        rel="noopener noreferrer"
        className="text-slate-500 underline hover:text-slate-700"
      >
        Terms of Service
      </a>{' '}
      and{' '}
      <a
        href={Urls.privacy_policy}
        target="_blank"
        rel="noopener noreferrer"
        className="text-slate-500 underline hover:text-slate-700"
      >
        Privacy Policy
      </a>
    </p>
  );
}

export default LegalDisclaimer;
